export default __webpack_public_path__ + "static/media/phishing.815fd5f1.svg";